import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, catchError, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  constructor(private http: HttpClient) { }

  // v1.0/driver?apexid=zhangw13
  getDriverByApexId(apexId:string): Observable<any> {
    
    let url=`${environment.api.uri}v1.0/driver?apexid=${apexId}`;
    return this.http.get<any>(url);
  }

}
